export enum PageState {
    VIEW = 1,
    ADD= 2,
    EDIT= 3,
    EDIT_FIELDS= 4,
    COPY= 5
}
